import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const TextStylesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const FontRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.theme.size.L};
  height: ${props => props.theme.size.L};
  border: none;
  border-radius: ${props => props.theme.primitives.radius.radius1};
  background: ${props => (props.active ? props.theme.colors.border.default : 'transparent')};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};

  &:hover {
    background: ${props => props.theme.colors.background.secondary};
  }
`
